var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("line",{"y1":"-0.5","x2":"26","y2":"-0.5","transform":"matrix(1 -1.74846e-07 -1.74846e-07 -1 0 6.5)","stroke":"black","key":0}),React.createElement("path",{"d":"M20 13L26 7L20 0.999999","stroke":"black","key":1})]);
}

ArrowRight.defaultProps = {"width":"27","height":"14","viewBox":"0 0 27 14","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
